import Modal from '@mui/material/Modal';
import React from 'react';
import Box from '@mui/material/Box';

export const MyMModal = (props) => {
  const { width, height, ...other } = props;
  return (
    <Modal {...other}>
      <Box sx={{
        background: '#fff',
        width: width,
        height: height,
        top: '50%',
        left: '50%',
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        overflow: 'auto',
        padding: '15px',
      }}>
        {props.children}
      </Box>
    </Modal>
  )
}

